import React from 'react';
import axios from 'axios';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import  { Redirect } from 'react-router-dom';
import socketIOClient from "socket.io-client";

class Header extends React.Component{
    
    constructor(props) {
        super(props);
        this.state = {

            show : false,

            redirect : false,

            status:false,

            showInfo: true,

            showUserMenu: false,

            showClip:false,

        };
    }

    
    hideIcon() {
        this.setState({show:false});
    }

    hideProfile() {
        this.setState({showUserMenu:false});
    }

    showOption = () => {

        this.setState({show:!this.state.show});

        var jwt = require('jwt-simple');


        var payload = { dir: this.props.page , status:(this.props.status==null|this.props.status==false)?false:this.props.status};


        var encoded = jwt.encode(payload, 'copack');

        console.log(encoded); //=> { foo: 'bar' }


        this.setState({value:process.env.REACT_APP_BASE_URL +'shared/' +encoded});
    }



    copyCodeToClipboard = () => {
        const el = this.textArea
        el.select()
        document.execCommand("copy")
        this.setState({
            show:false,
            showClip:true,
        });

        setTimeout(() => {
            this.setState({
                showClip:false,
            });
        }, 2000);
    }

    signOutUser = () =>{

       

        firebase.auth().signOut().then(function() {
            
        }).catch(function(error) {
            // An error happened.
            console.log(error);
        });

        localStorage.clear();
    
        this.setState({redirect:true});

    }

    doit = () =>{
        if(!this.state.showInfo){
            this.props.showRestricModal(true, 'This feature is available only in the premium version');
        }else{
            this.setState({
                status:!this.state.status
            },function(){
                
                var jwt = require('jwt-simple');


                var payload = { dir: this.props.page , status:this.state.status};
        
                console.log(payload);
        
                var encoded = jwt.encode(payload, 'copack');
        
                console.log(encoded); //=> { foo: 'bar' }
        
        
                this.setState({value:process.env.REACT_APP_BASE_URL+'shared/'+encoded});
            });
        }
        

      
    }

    componentDidMount() {
        const data ={
            uid : localStorage.getItem('uid')
        }
        axios.post(process.env.REACT_APP_API_HOST+'restrictions',data)
        .then(restrictions => {

            console.log(restrictions);

            if(restrictions.data && !restrictions.data.share){
                this.setState({showInfo: false})
            }
        })
        const socket = socketIOClient(process.env.REACT_APP_API_HOST);
        socket.on("premium-account",data => {
            console.log(data);
            if(data.email == localStorage.getItem('email'))
                this.setState({showInfo: true})
        });

        socket.on("cancel-subscription",data => {
            if(data.email == localStorage.getItem('email'))
                this.setState({showInfo: false})
        });
    }

    goToPricePage= ()  => {
        window.open("/pricing", "_blank")
    }

    showUserOption = ()  => {
        this.setState({showUserMenu:!this.state.showUserMenu});
    }
    
    hideAll(){
        this.hideIcon()
        //this.hideProfile()
    }

    showModal(option) {
        this.hideProfile()
        this.props.showProfileModal(true,option)
    }

    render(){

        const { redirect } = this.state;

        if(redirect){
            return <Redirect to="/login"></Redirect>
        }

        return(
            <div className="header">
                <div className="header-subscription">
                {this.state.showInfo!=true?<button className="btn-subscription" onClick={() => this.goToPricePage()}>Buy subscription</button>:""}
                </div>
                <div className="header-option">
                    <div onClick={this.showOption} className="shared-option">
                        Share
                        <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 1.5L13.3333 4.83333M10 1.5V11.5V1.5ZM10 1.5L6.66667 4.83333L10 1.5Z" stroke="#5A687C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M1.66667 13.1667L2.18417 15.2375C2.2743 15.5981 2.48236 15.9182 2.77528 16.1469C3.0682 16.3757 3.42918 16.5 3.80084 16.5H16.1992C16.5708 16.5 16.9318 16.3757 17.2247 16.1469C17.5177 15.9182 17.7257 15.5981 17.8158 15.2375L18.3333 13.1667" stroke="#5A687C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <div className="profile-container">
                        <div onClick={this.showUserOption} className="profile-image">
                            <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.86223 7.7C8.58609 7.7 8.36223 7.92386 8.36223 8.2C8.36223 8.47614 8.58609 8.7 8.86223 8.7V7.7ZM9.06374 8.2L9.06388 7.7H9.06374V8.2ZM10.7673 9.7768L10.2709 9.83599L10.2709 9.83609L10.7673 9.7768ZM10.9912 11.6512L11.4876 11.592L11.4876 11.5919L10.9912 11.6512ZM9.85486 13L9.85497 12.5H9.85486V13ZM2.14514 13V12.5L2.14503 12.5L2.14514 13ZM1.00884 11.6512L1.50532 11.7104L1.50533 11.7103L1.00884 11.6512ZM1.23209 9.7768L0.735607 9.71761L0.7356 9.71766L1.23209 9.7768ZM2.93684 8.2L2.93664 8.7H2.93684V8.2ZM3.13777 8.7C3.41391 8.7 3.63777 8.47614 3.63777 8.2C3.63777 7.92386 3.41391 7.7 3.13777 7.7V8.7ZM8.36223 4C8.36223 5.40312 7.28274 6.5 6 6.5V7.5C7.8788 7.5 9.36223 5.91059 9.36223 4H8.36223ZM6 6.5C4.71726 6.5 3.63777 5.40312 3.63777 4H2.63777C2.63777 5.91059 4.1212 7.5 6 7.5V6.5ZM3.63777 4C3.63777 2.59688 4.71726 1.5 6 1.5V0.5C4.1212 0.5 2.63777 2.08941 2.63777 4H3.63777ZM6 1.5C7.28274 1.5 8.36223 2.59688 8.36223 4H9.36223C9.36223 2.08941 7.8788 0.5 6 0.5V1.5ZM8.86223 8.7H9.06374V7.7H8.86223V8.7ZM9.06359 8.7C9.35327 8.70009 9.63686 8.81084 9.86036 9.01771L10.5396 8.28382C10.1357 7.90999 9.61121 7.70016 9.06388 7.7L9.06359 8.7ZM9.86036 9.01771C10.0845 9.22515 10.2326 9.5154 10.2709 9.83599L11.2638 9.71761C11.1983 9.16768 10.9429 8.65709 10.5396 8.28382L9.86036 9.01771ZM10.2709 9.83609L10.4947 11.7105L11.4876 11.5919L11.2638 9.71751L10.2709 9.83609ZM10.4947 11.7104C10.5068 11.8122 10.4981 11.9154 10.4694 12.0128L11.4286 12.2954C11.4958 12.0676 11.5158 11.8279 11.4876 11.592L10.4947 11.7104ZM10.4694 12.0128C10.4407 12.1101 10.3931 12.1984 10.3309 12.2721L11.0957 12.9164C11.2485 12.7351 11.3615 12.5232 11.4286 12.2954L10.4694 12.0128ZM10.3309 12.2721C10.2688 12.3458 10.1939 12.4032 10.1121 12.4419L10.5394 13.346C10.7536 13.2448 10.9429 13.0978 11.0957 12.9164L10.3309 12.2721ZM10.1121 12.4419C10.0303 12.4805 9.94277 12.5 9.85497 12.5L9.85474 13.5C10.0917 13.5001 10.3251 13.4473 10.5394 13.346L10.1121 12.4419ZM9.85486 12.5H2.14514V13.5H9.85486V12.5ZM2.14503 12.5C2.05723 12.5 1.96967 12.4805 1.88792 12.4419L1.46062 13.346C1.67489 13.4473 1.90835 13.5001 2.14526 13.5L2.14503 12.5ZM1.88792 12.4419C1.80609 12.4032 1.73117 12.3458 1.66908 12.2721L0.904299 12.9164C1.05713 13.0978 1.24645 13.2448 1.46062 13.346L1.88792 12.4419ZM1.66908 12.2721C1.60692 12.1984 1.55927 12.1101 1.53059 12.0128L0.571354 12.2954C0.638481 12.5232 0.751525 12.7351 0.904299 12.9164L1.66908 12.2721ZM1.53059 12.0128C1.5019 11.9154 1.49318 11.8122 1.50532 11.7104L0.512352 11.592C0.484225 11.8279 0.504235 12.0676 0.571354 12.2954L1.53059 12.0128ZM1.50533 11.7103L1.72858 9.83594L0.7356 9.71766L0.512345 11.5921L1.50533 11.7103ZM1.72857 9.83599C1.76681 9.51525 1.91509 9.22488 2.13937 9.01743L1.46035 8.28331C1.05676 8.65662 0.801204 9.16742 0.735607 9.71761L1.72857 9.83599ZM2.13937 9.01743C2.36304 8.81055 2.64682 8.69988 2.93664 8.7L2.93704 7.7C2.38945 7.69978 1.86456 7.90944 1.46035 8.28331L2.13937 9.01743ZM2.93684 8.7H3.13777V7.7H2.93684V8.7Z" fill="white"/>
                            </svg>
                        </div>
                    </div>
                </div>
                <div className='bg-total' onClick={this.hideIcon.bind(this)} style={{visibility: this.state.show==true ? 'visible' : 'hidden' }} >
                    <div className="header-list-option" style={{visibility: this.state.show ? 'visible' : 'hidden' }}>
                        <div className="header-flex">       
                            <input ref={(textarea) => this.textArea = textarea} type="text" value={this.state.value}></input>
                            <button className="btn-copy" onClick={() => this.copyCodeToClipboard()}>Copy Link</button>
                            <div className="status-document">
                                <span>{this.    state.status===true?"This page is private":"This page is public"}</span>
                                <img src={this.state.status===true?require('../Assets/private.png'):require('../Assets/public.png')} alt="img"></img>        
                            </div>
                            <button className="btn-doit" onClick={() => this.doit()}>{this.state.status===true?"Do it public":"Do it private"}</button>
                        </div>
                    </div>
                </div>
                <div className='bg-total' onClick={this.hideProfile.bind(this)} style={{visibility: this.state.showUserMenu==true ? 'visible' : 'hidden' }} >
                    <div className="header-user-options" style={{visibility: this.state.showUserMenu==true ? 'visible' : 'hidden' }}>
                        <div className="user-options">
                            <div className="profile-container">
                                <img onClick={this.showUserOption} src={this.props.profileImage}/>
                            </div>
                            <button onClick={() => this.showModal('profile')} >Profile</button>
                            {this.state.showInfo===true?<button onClick={() => this.showModal('leads')} >Leads</button>: ''}
                            <button onClick={this.signOutUser}>Sign out</button>
                        </div>
                    </div>
                </div>
                <div className={this.state.showClip===true?'modal-clip fadeIn':'modal-clip fadeOut'}>
                    <div className='img-clip'>
                        <img src={require('../Assets/Check Circled.png')}></img>
                    </div>
                    <div className='clip-text'>
                        <span>Link copied to clipboard</span>
                    </div>
                </div>
            </div>
        );
    }
}

export default Header;